


















































































































































































































































































































































































































































































































































































import Vue from 'vue';
import {
  Component, Inject, Watch,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import { TextBoxDatePicker } from '@kasasa/portal-components';
import { Alert, NoticeClass } from '@kasasa/fbase-components/lib';
import { KCardHeader, KCardHeaderBtn } from '@kasasa/fbase-components';
import KasasaUpgradeView from '@/views/KasasaUpgradeView.vue';
import LinkingSheet from '@/components/ficonfigurationsettings/LinkingSheet.vue';
import {
  FiConfiguration,
  FiConfigurationResource,
} from '@/api/ficonfiguration';
import {
  DateTool, DisplayAccountProductCode, DisplayProduct, KasasaAccountUpgradeUtil,
} from '@/util';
import KasasaUpgradeCreateDialog from '@/components/KasasaUpgradeCreateDialog.vue';
import { KasasaUpgradeResource, KasasaUpgrade } from '@/api/kasasaupgrade';
import { ProductMapping, ProductMappingResource } from '@/api/productmapping';

@Component({
  computed: mapState(['fiId', 'configVersion']),
  components: {
    KCardHeader,
    KCardHeaderBtn,
    TextBoxDatePicker,
    LinkingSheet,
    KasasaUpgradeView,
    KasasaUpgradeCreateDialog,
  },
})
export default class FiConfigurationSettings extends Vue {
  headerItems: any = [
    {
      text: 'Rewards Configuration',
      disabled: false,
      link: false,
    },
    {
      text: 'FI Configuration',
      disabled: true,
    },
  ];

  @Inject('FiConfigurationResource')
  fiConfigurationResource!: FiConfigurationResource;

  @Inject('KasasaUpgradeResource')
  kasasaUpgradeResource!: KasasaUpgradeResource;

  @Inject('ProductMappingResource')
  productMappingResource!: ProductMappingResource;

  fiId!: number;

  config: FiConfiguration | null = null;

  loading: boolean = false;

  upgradesLoading: boolean = false;

  saving: boolean = false;

  valid: boolean = false;

  fileFormats = ['XLSX', 'CSV', 'TXT'];

  showLinkingSheet: boolean = false;

  enabledKasasaUpgrade: boolean = false;

  automatedFileDeliveryTimeError:string | null = null;

  automatedEmailDeliveryTimeError: string | null = null;

  allUpgrades: KasasaUpgrade[] = [];

  productMap: Map<number, ProductMapping> = new Map();

  nonKasasaProductCodes: DisplayAccountProductCode[] = [];

  kasasaProducts: DisplayProduct[] = [];

  static AUTOMATED_DELIVERY_TIME_TOO_LATE:string = 'Delivery time must be earlier than 11pm';

  static DELIVERY_TIME_IS_REQUIRED:string = 'Delivery time is required';

  mounted() {
    this.loadConfig();
  }

  @Watch('fiId')
  loadConfig() {
    this.config = null;
    this.loading = true;
    this.upgradesLoading = true;

    const allPromises:Promise<any>[] = [];
    allPromises.push(this.fiConfigurationResource.getFiConfiguration(this.fiId));
    allPromises.push(this.productMappingResource.get(this.fiId));
    allPromises.push(this.kasasaUpgradeResource.getAll(this.fiId));

    Promise.all(allPromises).then((results:any[]) => {
      const configurations: FiConfiguration = results[0];
      this.resetConfigurations(configurations);

      const productMappings: ProductMapping[] = results[1];
      KasasaAccountUpgradeUtil.buildProductMap(productMappings, this.productMap);

      this.allUpgrades = results[2];
      if (this.allUpgrades && this.allUpgrades.length > 0) {
        this.enabledKasasaUpgrade = true;
      } else {
        this.enabledKasasaUpgrade = false;
      }

      this.kasasaProducts = [];
      this.nonKasasaProductCodes = [];
      KasasaAccountUpgradeUtil.buildProductListsForSelect(productMappings, this.kasasaProducts, this.nonKasasaProductCodes);
    }).catch((error) => {
      this.showError(error);
    }).finally(() => {
      this.loading = false;
      this.upgradesLoading = false;
    });
  }

  reloadKasasaUpgrades() {
    this.upgradesLoading = true;
    this.kasasaUpgradeResource.getAll(this.fiId).then((upgrades: KasasaUpgrade[]) => {
      this.allUpgrades = upgrades;
      if (this.allUpgrades && this.allUpgrades.length > 0) {
        this.enabledKasasaUpgrade = true;
      } else {
        this.enabledKasasaUpgrade = false;
      }
    })
      .catch((error:any) => {
        this.showError(error);
      })
      .finally(() => {
        this.upgradesLoading = false;
      });
  }

  static simplifyTime(time: string | null): string | null {
    if (time !== null) {
      return time.substring(0, 5);
    }
    return null;
  }

  resetConfigurations(configurations: FiConfiguration) {
    this.config = { ...configurations };

    // Strip everything but hours and seconds from times
    this.config.coreFileDeliveryTime = FiConfigurationSettings.simplifyTime(this.config.coreFileDeliveryTime);
    this.config.ibLoginFileDeliveryTime = FiConfigurationSettings.simplifyTime(this.config.ibLoginFileDeliveryTime);
    this.config.automatedFileDeliveryTime = FiConfigurationSettings.simplifyTime(this.config.automatedFileDeliveryTime);
    this.config.endOfCycleEmailDeliveryTime = FiConfigurationSettings.simplifyTime(this.config.endOfCycleEmailDeliveryTime);

    if (!this.config.firstLoansCoreProcessingDate) {
      this.config.firstLoansCoreProcessingDate = DateTool.todayBackendDate();
    }
  }

  dateFormatRule = (value: string | null): boolean | string => {
    if (value == null) {
      return 'Posting File Date Folder Format is required.';
    }
    return true;
  }

  showError(error: any) {
    if (error.response && error.response.data && error.response.data.entity) {
      this.setError(error.response.data.entity);
    } else {
      this.setError('An unexpected error occurred.');
    }
  }

  setError(message: string) {
    const al = new Alert(message, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }

  rewardsProcessingClicked() {
    if (this.config && this.config.rewardsProcessingEnabled) {
      this.config.ascadProcessingEnabled = true;
    }
  }

  @Watch('config.loanStatusProcessingEnabled')
  onLoanStatusProcessingChange() {
    const config: FiConfiguration = this.config!;
    if (config && config.loanStatusProcessingEnabled) {
      config.fidilAccountProcessingEnabled = true;
    }
  }

  sendFilesDirectToCoreClicked() {
    if (this.config && this.config.sendFilesDirectToCore) {
      this.config.postingFilesInDatedFolder = false;
      (this.$refs.form as any).validate();
    }
  }

  @Watch('config.endOfCyclePostingFilesAutomated')
  @Watch('config.secondDaySweepFilesAutomated')
  @Watch('config.endOfCycleEmailsAutomated')
  @Watch('config.automatedFileDeliveryTime')
  @Watch('config.endOfCycleEmailDeliveryTime')
  validateAutomatedDeliveryTimes() {
    if (this.config?.endOfCyclePostingFilesAutomated === true || this.config?.secondDaySweepFilesAutomated === true) {
      if (FiConfigurationSettings.timeIsTooLateForAutomatedEOC(this.config?.automatedFileDeliveryTime)) {
        this.automatedFileDeliveryTimeError = FiConfigurationSettings.AUTOMATED_DELIVERY_TIME_TOO_LATE;
      } else if (this.config?.automatedFileDeliveryTime === null || this.config?.automatedFileDeliveryTime.length === 0) {
        this.automatedFileDeliveryTimeError = FiConfigurationSettings.DELIVERY_TIME_IS_REQUIRED;
      } else {
        this.automatedFileDeliveryTimeError = null;
      }
    }

    if (this.config?.endOfCycleEmailsAutomated === true) {
      if (FiConfigurationSettings.timeIsTooLateForAutomatedEOC(this.config?.endOfCycleEmailDeliveryTime)) {
        this.automatedEmailDeliveryTimeError = FiConfigurationSettings.AUTOMATED_DELIVERY_TIME_TOO_LATE;
      } else if (this.config.endOfCycleEmailDeliveryTime === null || this.config.endOfCycleEmailDeliveryTime.length === 0) {
        this.automatedEmailDeliveryTimeError = FiConfigurationSettings.DELIVERY_TIME_IS_REQUIRED;
      } else {
        this.automatedEmailDeliveryTimeError = null;
      }
    }
  }

  static timeIsTooLateForAutomatedEOC(time:string | null | undefined) : boolean {
    if (time) {
      const elements:string[] = time.split(':');
      if (elements.length > 0) {
        const hours:string = elements[0];
        if (parseInt(hours, 10) === 23) {
          return true;
        }
      }
    }
    return false;
  }

  saveFiConfigSettings() {
    this.saving = true;
    this.fiConfigurationResource
      .updateFiConfiguration(this.fiId, this.config!)
      .then((result: FiConfiguration) => {
        this.resetConfigurations(result);
        const al = new Alert('FI Configuration saved successfully.', NoticeClass.SUCCESS);
        al.setTimeout(5000);
        this.$store.dispatch('notices/add', al);
      })
      .finally(() => {
        this.saving = false;
      })
      .catch((error) => {
        this.showError(error);
      });
  }

  onUpgradeSaved(savedUpgrade:KasasaUpgrade) {
    const al = new Alert('FI Kasasa Upgrade Configuration saved successfully.', NoticeClass.SUCCESS);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);

    this.allUpgrades = [];
    this.reloadKasasaUpgrades();
  }

  onUpgradeDeleted(savedUpgrade:KasasaUpgrade) {
    const al = new Alert('FI Kasasa Upgrade Configuration deleted successfully.', NoticeClass.SUCCESS);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);

    this.allUpgrades = [];
    this.reloadKasasaUpgrades();
  }

  onUpgradeSaveError(error:any) {
    this.showError(error);
  }
}
